import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcJourney2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M12 1.75c2.83 0 5.393 1.147 7.248 3.002A10.218 10.218 0 0 1 22.25 12c0 2.83-1.147 5.393-3.002 7.248A10.218 10.218 0 0 1 12 22.25c-2.83 0-5.393-1.147-7.248-3.002A10.218 10.218 0 0 1 1.75 12c0-2.83 1.147-5.393 3.002-7.248A10.218 10.218 0 0 1 12 1.75Z"
        stroke="#321E37"
        strokeWidth={1.5}
        fill="#E6D7E8"
      />
      <path
        fill="#321E37"
        d="m16.664 7.781 1.172.938-6.524 8.154L6.97 12.53l1.06-1.06 3.158 3.156z"
      />
    </g>
  </svg>
);
export default SvgIcJourney2;
